import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "providers/Auth";
import { Redirect } from "shared/components/Redirect";
import { ComponentLoader } from "shared/components/ComponentLoader";

export const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { auth, type, partner, pms } = useAuthContext();

  useEffect(() => {
    if (auth)
      if (location.pathname === "/")
        if (type.isPropertyManager) navigate("/properties", { replace: true });
        else if (type.isBoomScreen)
          navigate("/applications", { replace: true });
        else if (type.isPMS && !pms.isAppfolio)
          navigate("/renters", { replace: true });
        else navigate("/rent-reporting", { replace: true });
  }, [location, auth, partner]);

  if (auth === null) return <Redirect to="/login" />;

  if (!auth) return <ComponentLoader />;

  return <Outlet />;
};
